import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {IonInput, ModalController} from '@ionic/angular';
import {CustomDollarAmountComponent} from '../custom-dollar-amount/custom-dollar-amount.component';
import {multiplyCurrency} from '../../_utils/currency-math';
import {Organization} from '../../_models/organization';
import {OrganizationService} from '../../_services/organization.service';

@Component({
    selector: 'bb-tip',
    templateUrl: './tip.component.html',
    styleUrls: ['./tip.component.scss']
})
export class TipComponent implements OnChanges, OnInit {
    @Input() tip: number;
    @Input() max: number;
    @Output() tipChange = new EventEmitter<number>();

    @Input() tabTotal: number;
    @Input() hideTip = false;

    @ViewChild('manualTip') manualTip: IonInput;

    organization: Organization;
    selectedTip = null;
    defaults = [];
    showMax = false;
    tipValue: number;
    xsCol = 6;
    medCol = 6;

    constructor(
        private organizationService: OrganizationService,
        private modalController: ModalController
    ) {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if ((!!changes.tabTotal && !changes.tabTotal.isFirstChange())
            || (!!changes.max && !changes.max.isFirstChange())) {
            this.calculateDefaults();
            this.calculateTip();
        }
    }

    ngOnInit(): void {
        this.organization = this.organizationService.currentValue;
        this.calculateDefaults();
        this.calculateTip();
    }

    calculateTip() {
        const initialTipValue = (!this.tipValue && this.tipValue !== 0) ? null : this.tipValue;
        let newTipValue = null;

        if (!this.selectedTip && this.selectedTip !== 0) {
            newTipValue = null;
        } else {
            let tmpTip = this.tipValue;
            if (this.selectedTip !== 'custom') {
                tmpTip = this.selectedTip.value;
            }

            if (!!this.max && tmpTip > this.max) {
                this.selectedTip = 'custom';
                newTipValue = this.max;
            } else if (tmpTip !== this.tipValue) {
                newTipValue = tmpTip;
            }
        }

        if (
            (!newTipValue && newTipValue !== 0 && (!!initialTipValue || initialTipValue === 0))
            || ((!!newTipValue || newTipValue === 0) && !initialTipValue && initialTipValue !== 0)
            || (newTipValue > -1 && newTipValue !== initialTipValue)
        ) {
            this.tipChange.emit(newTipValue);
        }
    }

    calculateDefaults() {
        this.defaults = [];
        const percents = !!this.organization && !!this.organization.tipDefinitions && this.organization.tipDefinitions.length > 0
            ? this.organization.tipDefinitions.split(',')
            : [18, 20, 25];

        percents.forEach(p => {
            this.defaults.push({percent: p, value: multiplyCurrency(this.tabTotal, p / 100)});
        });

        this.showMax = !!this.max && this.defaults.some(t => t.value > this.max);

        if (this.showMax) {
            this.defaults = this.defaults.filter(t => t.value < this.max);
        }

        const buttonCount = this.showMax ? this.defaults.length + 1 : this.defaults.length;

        if (buttonCount === 1) {
            this.xsCol = 12;
            this.medCol = 12;
        } else if (buttonCount === 2) {
            this.xsCol = 6;
            this.medCol = 6;
        } else if (buttonCount === 3) {
            this.xsCol = 4;
            this.medCol = 4;
        } else if (buttonCount === 4) {
            this.xsCol = 6;
            this.medCol = 3;
        } else if (buttonCount === 5) {
            this.xsCol = 6;
            this.medCol = 4;
        }
    }

    async clickCustom() {
        this.selectedTip = 'CUSTOM';
        const modal = await this.modalController.create({
            component: CustomDollarAmountComponent,
            componentProps: {
                amount: '',
                max: this.max,
                label: 'Tip'
            },
            breakpoints: [0.0, 1],
            initialBreakpoint: 1,
            cssClass: 'quick-input-modal'
        });
        await modal.present();

        modal.onDidDismiss().then(async (returnData) => {
            if (!!returnData && (!!returnData.data || returnData.data === 0)) {
                this.tipChange.emit(Number.parseFloat(returnData.data));
            }
        });
    }

    changedSelected(selection: any) {
        this.selectedTip = selection;
        if (this.selectedTip === 'NO_TIP') {
            this.tipChange.emit(0);
        } else if (this.selectedTip === 'MAX') {
            this.tipChange.emit(this.max);
        } else {
            this.calculateTip();
        }
    }

    manualEntry() {
        this.selectedTip = null;
    }
}
